import React from 'react';
import TransformSection from './common/transform-section';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import type { ObjectInspectorProps } from './types';

const FallbackInspector: React.FC<ObjectInspectorProps> = ({ object, editor }) => (
  <>
    <InspectorSection title="Object">
      <InspectorRow label="Type">
        <span>{object.type ?? 'unknown'}</span>
      </InspectorRow>
    </InspectorSection>
    <TransformSection object={object} editor={editor} />
  </>
);

export default FallbackInspector;
